import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Image } from "cloudinary-react";
import { Helmet } from "react-helmet";
import PageSEO from "../Components/PageSEO";
import "../masonry.css";
import Masonry from "react-masonry-css";
import ScrollReveal from "../Components/ScrollReveal";

const pressItems = [
  { publicId: "/img/press/bbc", href: "http://www.bbcamerica.com/anglophenia/2014/02/05/5-different-ways-brits-see-america", alt: "BBC America" },
  { publicId: "/img/press/cincyweekend", href: "http://www.cincyweekend.com/queen-city-underground-tour", alt: "Cincy Weekend" },
  { publicId: "/img/press/dailynewsnewyork", href: "http://www.nydailynews.com/life-style/beer-baseball-traditions-drive-home-fun-cincinnati-article-1.2259160", alt: "NY Daily News" },
  { publicId: "/img/press/fodorstravel", href: "http://www.fodors.com/world/north-america/usa/ohio/cincinnati/experiences/news/long-weekend-in-cincinnati-11724", alt: "Fodor's Travel" },
  { publicId: "/img/press/forbes", href: "https://stories.forbestravelguide.com/5-reasons-cincinnati-is-on-our-radar", alt: "Forbes Travel Guide" },
  { publicId: "/img/press/lonelyplanet", href: "https://www.lonelyplanet.com/usa/great-lakes/cincinnati/travel-tips-and-articles/offbeat-cincinnati-going-deep-in-ohios-quirkiest-city/40625c8c-8a11-5710-a052-1479d276befc", alt: "Lonely Planet" },
  { publicId: "/img/press/natgeo", href: "https://www.nationalgeographic.com/travel/city-guides/cincinnati-traveler", alt: "National Geographic" },
  { publicId: "/img/press/nyt", href: "https://www.nytimes.com/interactive/2017/08/17/travel/what-to-do-36-hours-in-cincinnati-ohio.html", alt: "New York Times" },
  { publicId: "/img/press/politico", href: "https://www.politico.com/magazine/story/2016/06/what-works-cincinnati-ohio-over-the-rhine-crime-neighborhood-turnaround-city-urban-revitalization-213969", alt: "Politico" },
  { publicId: "/img/press/midwest", href: "http://www.midwestliving.com/blog/travel/top-10-things-for-active-travelers-to-do-cincinnati", alt: "Midwest Living" },
  { publicId: "/img/press/fox19", href: "http://www.fox19.com", alt: "Fox 19" },
  { publicId: "/img/press/cincinnatimagazine", href: "http://www.cincinnatimagazine.com/top5/top-5-cincinnati-tours", alt: "Cincinnati Magazine" },
  { publicId: "/img/press/cincinnatirefined", href: "http://www.cincinnatimagazine.com/top5/top-5-cincinnati-tours", alt: "Cincinnati Refined" },
  { publicId: "/img/press/southernweekend", href: "http://thesouthernweekend.com/history-spookiness-queen-city-underground-tour", alt: "Southern Weekend" },
];

const breakpointColumnsObj = { default: 4, 991: 3, 768: 2 };

const Featured = () => {
  return (
    <>
      <PageSEO
        title="Featured In | American Legacy Tours"
        description="American Legacy Tours featured in National Geographic, New York Times, Lonely Planet, Forbes, BBC America &amp; more. Cincinnati's most recognized tour company."
        path="/featured"
      />

      <div style={{ background: "var(--brand-dark)", padding: "48px 0 40px" }}>
        <Container>
          <h2 style={{ color: "#fff", fontWeight: 800, fontSize: "clamp(1.6rem, 4vw, 2.2rem)", margin: 0 }}>
            As Featured In
          </h2>
          <p style={{ color: "rgba(255,255,255,0.6)", marginTop: 8 }}>
            American Legacy Tours has been recognized by leading publications worldwide.
          </p>
        </Container>
      </div>

      <section style={{ background: "#f8f7f4", padding: "48px 0 72px" }}>
        <Container>
          <ScrollReveal>
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column"
            >
              {pressItems.map((item) => (
                <a
                  key={item.publicId}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "block",
                    background: "#fff",
                    borderRadius: 8,
                    padding: 20,
                    marginBottom: 16,
                    boxShadow: "var(--shadow-card)",
                    transition: "box-shadow var(--transition), transform var(--transition)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "var(--shadow-hover)";
                    e.currentTarget.style.transform = "translateY(-3px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "var(--shadow-card)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <Image
                    cloudName="american-legacy-tours"
                    publicId={item.publicId}
                    alt={item.alt}
                    crop="fill"
                    quality="auto"
                    style={{ width: "100%", display: "block" }}
                    loading="lazy"
                    fetch_format="auto"
                  />
                </a>
              ))}
            </Masonry>
          </ScrollReveal>
        </Container>
      </section>
    </>
  );
};

export default Featured;
